import React, { useEffect, useState } from "react";

const Modal = ({ isOpen, onClose, children, title, bg='light' }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setShow(true), 10); // Delay to trigger animation
    } else {
      setShow(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div>
      {/* Modal Backdrop */}
      <div 
        className={`modal-backdrop fade ${show ? "show" : ""}`} 
        style={{ zIndex: 1050 }} 
        onClick={onClose}
      ></div>

      {/* Modal Container */}
      <div 
        className={`modal fade ${show ? "show d-block" : "d-none"}`} 
        tabIndex="-1" 
        role="dialog" 
        style={{ zIndex: 1055, transition: "opacity 0.3s ease-in-out" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className={`modal-content bg-${bg}`}>
            <div className="modal-header">
              <h6 className="modal-title">{title}</h6>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">{children}</div>
            <div className="modal-footer">
              <button type="button" className="btn btn-outline-dark btn-sm" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
